import React from 'react'
import RotateLoader from "react-spinners/RotateLoader";

const Loading = () => {
  return (
    <div className="flex w-full h-[100vh] z-[1000] justify-center items-center absolute bg-black/30">
      <div className='flex w-64  h-64 self-center bg-grey50/[0.6] backdrop-blur-sm items-center justify-center rounded-md'>
        <RotateLoader
          color="#435A6D"
          loading={true}
          css={{ display: "block", margin: "0 auto", borderColor: "red" }}
          speedMultiplier={1.5}
        />
      </div>
    </div>
  );
}

export default Loading